module.exports = __webpack_public_path__ + "img/Anlyst-logo-icon.5dac1f75.svg";